import React, {PropsWithChildren} from "react";
import {useStyles} from "@v2/components/controls/FormControl/FormControl.styles";

interface FormControlProps extends PropsWithChildren{
  label: string;
}

export const FormControl: React.FC<FormControlProps> = ({label, children}) => {
  const styles = useStyles();

  return (
    <div className={styles.formControl}>
      <span className={styles.label}>
        {label}
      </span>
      <div>
        {children}
      </div>
    </div>
  )
}